module.exports = __webpack_public_path__ + "static/media/the_cauldron_ic.ecb40d5c.svg";